import React from 'react'
import { Link } from 'react-router-dom'

function OfferTwo() {
    return (
        <section
            className="position-relative overflow-hidden space-bottom"
            id="destination-sec"
        >
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">Services We Offer</span>
                    <h2 className="sec-title">Our Amazing services</h2>
                </div>
                <div className="row gy-4 gx-4">
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/globalvisa1.png" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/service/1">Global Visa</Link>
                                </h3>
                                <p className="destination-text"></p>
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/holidays1.png" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/service/1">Holiday Packages</Link>
                                </h3>
                                <p className="destination-text"></p>
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/Flights1.png" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/service/1">Flights</Link>
                                </h3>
                                <p className="destination-text"></p>
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/hotel-booking.png" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/service/1"> Hotel Booking</Link>
                                </h3>
                                <p className="destination-text"></p>
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/cruise1.png" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/service/1">Cruise Bookings</Link>
                                </h3>
                                {/* <p className="destination-text">25 Listing</p> */}
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/travelinsurance-1.png" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/service/1">Travel Insurance</Link>
                                </h3>
                                {/* <p className="destination-text">26 Listing</p> */}
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/carrental1.png" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/service/1">Car Rental</Link>
                                </h3>
                                {/* <p className="destination-text">27 Listing</p> */}
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6">
                        <div className="destination-item th-ani">
                            <div className="destination-item_img global-img">
                                <img src="/assets/img/destination/uaevisa1.png" alt="" />
                            </div>
                            <div className="destination-content">
                                <h3 className="box-title">
                                    <Link to="/service/1">UAE Visa</Link>
                                </h3>
                                <p className="destination-text"></p>
                                <Link to="/contact" className="th-btn style4 th-icon">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default OfferTwo
